import { render } from "./DownloadExcel.vue?vue&type=template&id=5c3e9c7a"
import script from "./DownloadExcel.vue?vue&type=script&lang=js"
export * from "./DownloadExcel.vue?vue&type=script&lang=js"
script.render = render

export default script